module.exports = __webpack_public_path__ + "static/media/mapDetails.8a1d2e18.png";